import { getGeneralMeetToken, getTeamMeetToken } from '../../../apis/api.hca'

import { capitalize } from '../../../helpers/formatter'
import { useTeam } from '../Context/TeamContext'
import { useUIContext } from '../../../context/UIContext'
import { useUser } from '../../../context/UserContext'
import { Team } from '../../../apis/api.egg'
import { buildMeetUrl } from '../Helpers/meets'
import { useMyCourse } from '../../../hooks/ApiHooks/useCourses'

export const useOpenMeet = () => {
    const { team, algorithmID, courseID } = useTeam()
    const course = useMyCourse(courseID)
    const { token: accessToken, user, profiles } = useUser()
    const { toastError } = useUIContext()

    const { name, lastname } = user ?? {}
    const userName = capitalize(`${name} ${lastname}`)

    const meetVersion = course?.courseFlags?.sdkVersion ?? 0

    const openTeamMeet = async ({ number, isMentorTeam }: Partial<Pick<Team, 'number' | 'isMentorTeam'>>) => {
        if (!team || !user || !team.settings?.meeting) return

        const { meeting } = team.settings
        try {
            let meetUrl: string | null = null

            switch (meeting.type) {
                case 'zoom-sdk':
                case 'zoom-sdk-auto':
                case 'egg': {
                    const profile = profiles.find(({ course }) => course._id === team.course._id)
                    if (!profile) return
                    const { _profileId } = profile
                    const _classId = team.course._id

                    const {
                        token: meetToken,
                        topic,
                        meet_base_url: meetBaseUrl,
                    } = await getTeamMeetToken({
                        tableNumber: number,
                        tableType: isMentorTeam ? 'm' : 't',
                        algorithmId: algorithmID,
                        _classId,
                        _profileId,
                    })

                    meetUrl = buildMeetUrl({
                        baseUrl: meetBaseUrl,
                        meetVersion,
                        topic,
                        zoomToken: meetToken,
                        widgetToken: accessToken,
                        name: userName,
                        courseName: team.teamName,
                        _classId,
                        algorithmId: algorithmID,
                    })

                    break
                }
            }

            if (meetUrl) window.open(meetUrl, '_blank')
        } catch (error) {
            toastError(error)
        }
    }

    const openGeneralMeet = async () => {
        if (!team || !user || !team.settings?.meeting) return

        const { meeting } = team.settings

        try {
            let meetUrl: string | null = null

            switch (meeting.type) {
                case 'egg': {
                    const profile = profiles.find(({ course }) => course._id === team.course._id)
                    if (!profile) return
                    const { _profileId } = profile
                    const _classId = team.course._id

                    const {
                        token: meetToken,
                        topic,
                        meet_base_url: meetBaseUrl,
                    } = await getGeneralMeetToken({
                        _classId,
                        _profileId,
                    })

                    meetUrl = buildMeetUrl({
                        baseUrl: meetBaseUrl,
                        meetVersion,
                        topic,
                        zoomToken: meetToken,
                        widgetToken: accessToken,
                        name: userName,
                        courseName: team.teamName,
                        _classId,
                        algorithmId: algorithmID,
                    })
                    break
                }
                case 'zoom-hybrid':
                    meetUrl = meeting.url[0].zoomURL
                    break
                default:
                    meetUrl = meeting.url ?? null
            }

            if (meetUrl) window.open(meetUrl, '_blank')
        } catch (error) {
            toastError(error)
        }
    }

    return { openTeamMeet, openGeneralMeet }
}
